<template>
  <div class="dropdown mr-2 mb-2 flex-1">
    <button class="btn d-flex align-items-center w-100 px-2 dropdown-toggle" :class="buttonClass"
      data-toggle="dropdown" data-display="static">
      <span class="mr-1" :class="{ [icon]: true, 'text-primary': isFiltering }"></span>
      <span class="mr-auto text-truncate" :class="{ 'font-weight-bold': isFiltering }">{{ title }}</span>
    </button>
    <div class="dropdown-menu filter-dropdown-menu" :style='{ width }'>
      <form class="px-3 py-2">
        <slot></slot>
      </form>
    </div>
  </div>
</template>

<style scoped>
/* Keep long option lists (e.g. every shipping method / plan) scrollable and painted above the
   table, rather than overflowing the page. Restores the stacking the w-full-page hack used to give. */
.filter-dropdown-menu {
  max-height: 70vh;
  overflow-y: auto;
  z-index: 1030;
}

/* min-width:0 lets this flex column shrink below its content so a long title (e.g. "Shipping
   method") truncates with an ellipsis instead of overflowing into the next filter button. */
.dropdown {
  min-width: 0;
}
</style>

<script>
export default {
  props: {
    title: String,
    icon: String,
    isFiltering: Boolean,
    width: {
      type: String,
      default: '300px'
    }
  },

  computed: {
    buttonClass() {
      return {
        'btn-light': !this.isFiltering,
        'btn-dark': this.isFiltering
      }
    }
  }
}
</script>
